import { useEffect } from 'react'
import { IconLoadingSpinner } from '@zoom/icons-react'
import { useAppSelector } from '../hooks'
import { selectApp } from '../app/root'
import {
  useCreateFilePermissionMutation,
  useRequiresEmailConsentQuery,
} from '../app/appApiQueries'
import ToastNotification from './ToastNotification'

const GrantingDocAccess = () => {
  const app = useAppSelector(selectApp)!
  const toastContent = `${app === 'Microsoft' ? 'Microsoft OneDrive' : 'Google Drive'} connected to Zoom`
  const { needsEmailConsent } = useRequiresEmailConsentQuery(app, {
    selectFromResult: (result) => ({
      needsEmailConsent: result?.data?.needsEmailConsent,
    }),
  })
  const [createFilePermission] = useCreateFilePermissionMutation()

  // if we do not need email consent, create file permission which will set the collab file in store
  useEffect(() => {
    if (needsEmailConsent !== undefined && !needsEmailConsent) {
      createFilePermission(app)
    }
  }, [needsEmailConsent, createFilePermission, app])

  return (
    <>
      {app && (
        <ToastNotification
          type='info'
          content={toastContent}
          duration={3000}
          classes='whitespace-nowrap'
        />
      )}

      <div className='flex h-screen items-center justify-center px-4 md:px-10'>
        <div className='flex w-full max-w-[800px] flex-col items-center'>
          <IconLoadingSpinner className='animate-spin text-[32px] text-[#0E71EB]' />

          <h1 className='mt-4 text-base font-[590] text-[#323539]'>
            Granting document access...
          </h1>
        </div>
      </div>
    </>
  )
}

export default GrantingDocAccess
